import React from "react";
// import {  useSelector } from "react-redux";
import styles from "./dashboard.module.css";
import { ReactComponent as Plus } from "../../utils/assets/plus.svg";
import moment from "moment";
import { ReactComponent as NotesGroupIcon } from "../../utils/assets/notes-group-users.svg";
import { ReactComponent as NotesPersonIcon } from "../../utils/assets/notes-person.svg";
import Avatar from "@mui/material/Avatar";
import { Typography } from "@material-ui/core";

export default function NotesDisplay({ setOpen, note, date, setNoteDetails, setReadJournal }) {
    // const loggedInUserId = useSelector((state) => state.auth.userId);
   
    const handleReadNote = (e) => {
        setNoteDetails(e);
        setReadJournal(true)
        setOpen(true)
    };

    const filterNotesByVisibility = (notes) => {
        if (!notes) return [];
        return notes.filter(note => {

            // as discussed, show all notes for now
            // if (note.visibility === 'private') {
            //     return note.creator_id === loggedInUserId;
            // }
            return true; // show all non-private notes
        });
    };

    const renderMetaIcon = (notes) => {
        if (Object.keys(notes.Group).length > 0) {
            return (
                <NotesGroupIcon
                    className={styles.noteGroupIcon}
                    aria-hidden
                />
            );
        }

        if (Object.keys(notes.Player).length > 0) {
            if (notes?.Player?.avatar_url) {
                return (
                    <Avatar
                        alt={notes?.Player?.first_name}
                        src={notes?.Player?.avatar_url}
                    />
                );
            }

            return (
                <NotesPersonIcon
                    className={styles.notePersonIcon}
                    aria-hidden
                />
            );
        }

        return null;
    };

    const renderMetaLabel = (notes) => {
        if (Object.keys(notes.Group).length > 0) {
            return notes.Group?.name;
        }

        if (Object.keys(notes.Player).length > 0) {
            return `${notes?.Player?.first_name} ${notes?.Player?.last_name ? notes?.Player?.last_name : ""}`.trim();
        }

        return null;
    };

    return (
        <>
            <div
                style={{
                    backgroundColor: "var(--primary-popup-background-color)",
                    padding: "1rem",
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    marginTop: "-0.4rem",
                    marginBottom: -7,
                    borderBottom: "1px solid var(--primary-popup-stroke-color)",
                }}
            >
                <p className={styles.descriptionTittle}>Notes</p>
                <Plus
                    className={styles.plusIcon}
                    style={{ width: "0.8rem", height: "0.8rem", cursor: "pointer" }}
                    onClick={() => setOpen(true)}
                />
            </div>
            <div style={{ maxHeight: 400, overflow: "auto" }}>
                {(() => {
                    const dateKey = moment(date).format("YYYY-MM-DD");
                    const notesArr = note[dateKey];
                    const filteredNotes = filterNotesByVisibility(notesArr);
                    if (filteredNotes && filteredNotes.length > 0) {
                        return filteredNotes.map((notes) => {
                            const metaIcon = renderMetaIcon(notes);
                            const metaLabel = renderMetaLabel(notes);
                            const hasCreator = Object.keys(notes.Creator).length !== 0;

                            return (
                                <div
                                    className={styles.noteItem}
                                    key={notes.id}
                                    onClick={() => handleReadNote(notes)}
                                >
                                    <div className={styles.noteItemHeader}>
                                        <p className={styles.noteItemTitle}>
                                            {notes.title}
                                        </p>
                                        <p className={styles.noteItemTime}>
                                            {moment(notes.reading_time).format("hh: mm: ss a")}
                                        </p>
                                    </div>

                                    {(metaIcon || hasCreator) && (
                                        <div className={styles.noteItemMeta}>
                                            <div className={styles.noteItemMetaLeft}>
                                                {metaIcon && (
                                                    <div className={styles.wrapper}>
                                                        {metaIcon}
                                                    </div>
                                                )}
                                                {metaLabel && (
                                                    <p className={styles.noteItemMetaLabel}>
                                                        {metaLabel}
                                                    </p>
                                                )}
                                            </div>
                                            {/* {hasCreator && (
                                                <p className={styles.noteItemMetaRight}>
                                                    by {`${notes?.Creator?.first_name} ${notes?.Creator?.last_name ? notes?.Creator?.last_name : ""}`.trim()}
                                                </p>
                                            )} */}
                                        </div>
                                    )}

                                    <p className={styles.noteItemBody}>
                                        {notes.note}
                                    </p>
                                </div>
                            );
                        });
                    } else {
                        return (
                            <Typography variant="h6" style={{ padding: "1rem", color: "var(--primary-text-color-80)" }}>
                                No notes to display.
                            </Typography>
                        );
                    }
                })()}
            </div>
        </>
    );

}
